import React, { useState, useEffect, useRef } from 'react';
import { useStore } from 'react-context-hook'
import { TouchableOpacity, ImageBackground, Image, View, ScrollView, ViewPagerAndroid, TextComponent } from "react-native";
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Text,  Left,  Right,  Body, List, ListItem, Thumbnail, Content } from "native-base";
import { Layouts } from '../../utils';
import Styles from '../../Styles'
import Sentry from '../../utils/Sentry'
import { GiftedChat } from 'react-native-gifted-chat'
import Swiper from 'react-native-deck-swiper'
import * as DashboardData from '../../utils/TestData/DashboardData'
import * as ProfileData from '../../utils/TestData/ProfileData'

export default function MessagesMainScreen({ navigation }) {

    const [displayDesktop] = useStore('displayDesktop')

    const [profile, setProfile] = useState(ProfileData.profileData1)
    const [profilePics, setProfilePics] = useState(DashboardData.matchData)
    const [picCount, setPicCount] = useState(profilePics.length)

    return (
        <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.generalAppContainer.desktop : Styles.Typography.generalAppContainer.mobile}>

            <View style={displayDesktop ? Styles.Typography.generalViewContainer.desktop : Styles.Typography.generalViewContainer.mobile}>

                <Styles.Components.ProfileCardSlim />          

            </View>   

        </ImageBackground>        
    )
}